import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";
import Footer from "./Footer";
// import Header from "./Header";
// import Sidebar from "./Sidebar";
// import { Link } from "react-router-dom";
// import { data } from "jquery";

export default function SubscriberHistory(props) {
  const { id } = props.match.params;
  //console.log(id);
  const { token } = isAutheticated();
  const [order, setOrder] = useState(false);
  const [address, setAddress] = useState(false);

  const [watchlist, setWatchlist] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    setLoading(true)
    axios
      .get(`${API}/api/user/subscriber/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        let data = response.data.data;
        setOrder(data);
        // setWatchlist(response.data.view)
        console.log(response.data.data);
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setLoading(false)
      })
  }, [id, token]);

  useEffect(() => {
    // console.log("_id",id)

    const getAddress = async () => {
      const res = await axios.get(
        `${API}/api/user/subscribers/address/${order?.subscriber?._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAddress(res.data.data);
      // setWatchlist(response.data.view)
      console.log(res.data.data);
    };
    if (order) {
      getAddress();
    }
  }, [order, token]);

  return (
    // <div id="layout-wrapper">
    //   <Header />
    //   <Sidebar />

    // </div>
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Subscribers - Subscribers Details</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>
                      Subscriber ID {order._id}
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row'>
                    <div className='col-md-12 col-lg-6 col-xl-6'>
                      <h1 className='text-left head-small'>
                        Subscriber ID: {order._id}
                      </h1>

                      <form>
                        <div className='row mt-20'>
                          {/* <div className="col-md-4 font-b">User Name</div> */}
                          {/* {!(Object.keys(order).length === 0 && order.constructor === Object) && order.subscriber && 
                          <div className="col-md-8">{order.subscriber.firstName } {order.subscriber.lastName}</div>
                          } */}
                        </div>

                        <div className='row mt-20'>
                          <div className='col-md-4 font-b'>
                            Subscription Type
                          </div>
                          <div className='col-md-8'>{order?.subType}</div>
                        </div>
                        <div className='row mt-20'>
                          <div className='col-md-4 font-b'>
                            Subscriber Email
                          </div>
                          <div className='col-md-8'>
                            {order?.subscriber?.email}
                          </div>
                        </div>
                        <div className='row mt-20'>
                          <div className='col-md-4 font-b'>Subscriber Name</div>
                          <div className='col-md-8'>
                            {order?.subscriber?.firstName}{" "}
                            {order?.subscriber?.lastName}
                          </div>
                        </div>

                        {/* <div className="row mt-20">
                          <div className="col-md-4 font-b">Status</div>
                          {!(Object.keys(order).length === 0 && order.constructor === Object) && order.subscriber &&
                            order.subscriber.status && <div className="col-md-8">present</div>
                          }
                          {!(Object.keys(order).length === 0 && order.constructor === Object) && order.subscriber &&
                            !order.subscriber.status && <div className="col-md-8">suspend</div>
                          }
                        </div> */}

                        <div className='row mt-20'>
                          {/* <div className="col-md-4 font-b">Ordered On</div> */}
                          <div className='col-md-4 font-b'>
                            Subscription Start
                          </div>
                          {!(
                            Object.keys(order).length === 0 &&
                            order.constructor === Object
                          ) && (
                              // <div className="col-md-8">{(new Date(order.createdAt)).toDateString()}</div>
                              <div className='col-md-8'>
                                {new Date(order.subStart).toDateString()}
                              </div>
                            )}
                        </div>
                        <div className='row mt-20'>
                          {/* <div className="col-md-4 font-b">Ordered On</div> */}
                          <div className='col-md-4 font-b'>
                            Subscription End
                          </div>
                          {!(
                            Object.keys(order).length === 0 &&
                            order.constructor === Object
                          ) && (
                              // <div className="col-md-8">{(new Date(order.createdAt)).toDateString()}</div>
                              <div className='col-md-8'>
                                {new Date(order.subEnd).toDateString()}
                              </div>
                            )}
                        </div>

                        <div className='row mt-20'>
                          <div className='col-md-4 font-b'>Amount</div>
                          {!(
                            Object.keys(order).length === 0 &&
                            order.constructor === Object
                          ) && (
                              <div className='col-md-8'>
                                <i className='fa fa-inr' aria-hidden='true'></i>
                                {order.amount}
                              </div>
                            )}
                        </div>
                        {/* <div className="row mt-20">
                          <div className="col-md-4 font-b">Watch History</div>
                          {order.watchhistory?.map((video, index) => {
                            console.log(order.watchhistory.length, index);
                            return <div className="col-md-8" key={index}>
                              {video.vid.title}{order.watchhistory.length === (index + 1) ? "." : ","}</div>
                          })
                          }
                        </div>
                        <div className="row mt-20">
                          <div className="col-md-4 font-b">Watch History</div>
                          {watchlist?.video?.map((video, index) => {
                            console.log(order.watchhistory.length, index);
                            return <div className="col-md-8" key={index}>
                              {video.title}{watchlist.video.length === (index + 1) ? "." : ","}</div>
                          })
                          }
                        </div> */}

                        {/* <div className="row mt-20">
                          <div className="col-md-4 font-b">Paid Through</div>
                          {!(Object.keys(order).length === 0 && order.constructor === Object) &&
                           <div className="col-md-8">
                           {order.processed_by}
                           </div>
                          }
                          
                        </div> */}

                        {/* <div className="row mt-20">
                          <div className="col-md-4 font-b">
                            Paypal Confirmation ID
                          </div>
                          {!(Object.keys(order).length === 0 && order.constructor === Object) &&
                          <div className="col-md-8">
                          {order.confirmationID}
                        </div>
                          }
                          
                        </div> */}

                        <div className='row mt-20'>
                          <div className='col-lg-12'>
                            <div className='form-group text-left'>
                              {/* <a href="/earning"> */}
                              <Link
                                className='btn btn-success btn-login waves-effect waves-light mr-3'
                                to='/subscribers'>
                                Back
                              </Link>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {address && (
              <div className='col-lg-12'>
                <div className='card'>
                  <div className='card-body'>
                    <div className='row'>
                      {address?.map((item, index) => (
                        <div key={index} className='col-12 mb-3'>
                          <h1 className='text-left head-small mb-0'>
                            Address {index + 1}
                          </h1>
                          <form>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>Name</div>
                              <div className='col-md-8'>{item?.Name}</div>
                            </div>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>
                                Address Line 1{" "}
                              </div>
                              <div className='col-md-8'>
                                {item?.Address_Line_1}
                              </div>
                            </div>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>Pin Code</div>
                              <div className='col-md-8'>{item?.Pin_Code}</div>
                            </div>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>Phone</div>
                              <div className='col-md-8'>
                                {item?.Contact_Number}
                              </div>
                            </div>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>Country</div>
                              <div className='col-md-8'>{item?.Country}</div>
                            </div>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>State</div>
                              <div className='col-md-8'>{item?.State}</div>
                            </div>
                            <div className='row mt-20'>
                              <div className='col-md-4 font-b'>City</div>
                              <div className='col-md-8'>{item?.City}</div>
                            </div>
                          </form>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
